<template>
  <div class="page-select">
    <div
      class="page-select-showing"
      v-if="showingEntries && pagination.total > 0"
    >
      <span class="d-inline-block me-4"
        >{{ $t("common.showing") }}
        {{
          pagination.per_page.label == $t("common.all_entries")
            ? 1
            : pagination.from
        }}
        {{ $t("common.showing_to") }}
        {{
          pagination.to < pagination.total ? pagination.to : pagination.total
        }}
        {{ $t("common.showing_of") }} {{ pagination.total }}
        {{ $t("common.entries") }}
      </span>
    </div>
    <div>
      <CustomSelect
        :filterable="true"
        :close-on-select="true"
        :options="options || defaultOptions"
        type="textarea"
        v-model="state.selectedOption"
        :searchable="false"
        @update:model-value="onPageChange"
      ></CustomSelect>
    </div>
  </div>
</template>

<script>
import { computed, reactive, watchEffect } from "vue"
import { useI18n } from "vue-i18n"
import CustomSelect from "../Form/CustomSelect.vue"

export default {
  components: { CustomSelect },
  name: "Perpage",
  emits: ["onPageChange"],
  props: {
    useDynamicUpdate: {
      type: Boolean,
      default: false
    },
    useFirstOptionAsDefault: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object
    },
    options: {
      type: Array,
      deep: true,
      default: null
    },
    action: {
      type: Function
    },
    showingEntries: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const defaultOptions = computed(() => [
      {
        label: "25",
        value: 25
      },
      {
        label: "50",
        value: 50
      },
      {
        label: "100",
        value: 100
      },
      {
        label: t("common.all_entries"),
        value: 75
      }
    ])

    const defaultValue = { label: "25 / page", value: 25 }
    const state = reactive({
      selectedOption: props.useFirstOptionAsDefault
        ? props?.options?.[0] || defaultValue
        : defaultValue
    })

    const pagination = computed(() => {
      return props.pagination
    })

    const onPageChange = (value) => {
      emit("onPageChange", value)
      state.selectedOption = value
    }

    watchEffect(() => {
      if (!props.useDynamicUpdate) return

      state.selectedOption = props.options.find(
        (option) => option.value === pagination.value.per_page.value
      )
    })

    return {
      state,
      onPageChange,
      defaultOptions
    }
  }
}
</script>
